<template>
    <v-app>
        <v-app-bar
        app
        color="secondary"
        dark
        flat
        >
            <div class="d-flex align-center primary--text">
                <v-img                
                class="shrink mr-2"
                contain
                src="../../assets/logo.png"
                transition="scale-transition"
                width="50"
                />
                {{ schoolName}}
                
            </div>

            <v-spacer></v-spacer>

            <v-btn
                color="primary"
                size="36"                
                fab
                dark
                small
                elevation="0"                
            >
            {{ userInitials }}               
            </v-btn>

            <Logout/>
        </v-app-bar>

        <v-main class="grey lighten-5" >            
            <v-container 
                fluid
                class="grey lighten-5"                               
            >                                   
                <v-row class="mt-4">
                    <v-card 
                        class="grey lighten-5 "                        
                        flat
                        width="460"
                        height="40"
                    >
                        
                        <div class="d-flex justify-center text-body-1 primary--text">
                            <span class="mr-3 d-flex align-end">Welcome</span> 
                            <span class="font-weight-light font-italic text-h5 d-flex align-end">{{ userRecord.first_name }} {{ userRecord.last_name }}</span>
                        </div>                       
                        
                    </v-card>
                    <v-spacer></v-spacer>
                </v-row>    
            
                <slot></slot>
                
            </v-container>
            <form-dialog/>                 
        </v-main>
    </v-app> 
    
</template>

<script>
import Logout from '../auth/Logout';
import FormDialog from '../FormDialog';
import { mapGetters } from 'vuex';

export default {
  name: 'App',

  components: {    
    Logout,      
    FormDialog,    
  },

  data: () => ({
     documentTop: true,     
     floatingButton: false,     
  }),

  methods: {
      quickScroll(){
          this.documentTop = !this.documentTop;
          if(this.documentTop){
              window.scrollTo(0, document.body.scrollHeight);
          }
      },
      changePassword(){
          this.$router.push('/registration/change-password');
      }

  },

  computed: {
      userRecord () {
        return JSON.parse(this.getUserRecord);
      },

      userInitials (){
          return this.userRecord.first_name[0] + this.userRecord.last_name[0];
      },
     
     
      ...mapGetters({
          schoolName: 'form/getSchoolName',
          getUserRecord: 'auth/getUserRecord',
      })
      
  }
};
</script>

<style scoped>
    .quick-navigation{
        position: fixed;       
    }
</style>
